import { createContext, useEffect, useState } from 'react';
import NRRemediationModal from './NRRemediationModal/NRRemediationModal';

export const RemediationContext = createContext({
  openRemediationModal: null,
  setOpenRemediationModal: () => {},
  showUnremediated: null,
  setShowUnremediated: () => {},
  rows: null,
  setRows: () => {},
  content: null,
  setContent: () => {},
  title: null,
  setTitle: () => {},
  vulnerabilities: null,
  setVulnerabilities: () => {},
  lastQueryVariables: null,
  setLastQueryVariables: () => {},
  lastQueryLicenseIssuesVariables: null,
  setLastQueryLicenseIssuesVariables: () => {},
  remediateAllVulnerabilitiesFilter: null,
  setRemediateAllVulnerabilitiesFilter: () => {},
  lastQuerySecretsVariables: null,
  setLastQuerySecretsVariables: () => {},
  lastQueryCryptographyVariables: null,
  setLastQueryCryptographyVariables: () => {}
});

function NRRemediationContextWrapper({ children }) {
  const [openRemediationModal, setOpenRemediationModal] = useState(false);
  const [showUnremediated, setShowUnremediated] = useState(false);
  const [rows, setRows] = useState([]);
  const [content, setContent] = useState(null);
  const [title, setTitle] = useState(null);
  const [vulnerabilities, setVulnerabilities] = useState([]);
  const [lastQueryVariables, setLastQueryVariables] = useState({});
  const [lastQueryLicenseIssuesVariables, setLastQueryLicenseIssuesVariables] = useState({});
  const [lastQuerySecretsVariables, setLastQuerySecretsVariables] = useState({});
  const [remediateAllVulnerabilitiesFilter, setRemediateAllVulnerabilitiesFilter] = useState();
  const [lastQueryCryptographyVariables, setLastQueryCryptographyVariables] = useState({});

  useEffect(() => {
    if (!openRemediationModal) {
      setRows([]);
    }
  }, [openRemediationModal]);

  const defaultValues = {
    openRemediationModal,
    setOpenRemediationModal,
    showUnremediated,
    setShowUnremediated,
    rows,
    setRows,
    vulnerabilities,
    setVulnerabilities,
    lastQueryVariables,
    setLastQueryVariables,
    remediateAllVulnerabilitiesFilter,
    setRemediateAllVulnerabilitiesFilter,
    content,
    setContent,
    title,
    setTitle,
    lastQueryLicenseIssuesVariables,
    setLastQueryLicenseIssuesVariables,
    lastQuerySecretsVariables,
    setLastQuerySecretsVariables,
    lastQueryCryptographyVariables,
    setLastQueryCryptographyVariables
  };

  return (
    <RemediationContext.Provider value={defaultValues}>
      <NRRemediationModal />
      {children}
    </RemediationContext.Provider>
  );
}

export default NRRemediationContextWrapper;
